import styled from "styled-components";
import { ClientSettingsTitleDefaultBox } from "./client-settings-title.default.box";

export const ClientSettingsTitleCasino777Box = styled(ClientSettingsTitleDefaultBox)`
    color: inherit;
`